import useRemovePointerEvent from '@/utils/hooks/useRemovePointerEvent'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { cn } from '@/lib/utils'
import { X } from 'lucide-react'

interface ModalContainerProps {
  title?: string | React.ReactNode
  show: boolean
  hasCloseButton?: boolean
  handleClose?: () => void
  children?: React.ReactNode
  modalClass?: string
  customWidth?: string
}

export default function ModalContainer({
  show,
  handleClose,
  children,
  modalClass,
  customWidth,
  hasCloseButton = false,
}: ModalContainerProps) {
  const { handleRemovePointerEvent } = useRemovePointerEvent(show)

  handleRemovePointerEvent()
  return (
    <>
      <AlertDialog open={show} onOpenChange={handleClose}>
        <AlertDialogContent
          className={cn(customWidth ? customWidth : 'md:w-[27rem]', modalClass)}
        >
          <AlertDialogTitle className='hidden sr-only' />
          <AlertDialogDescription className='hidden sr-only' />
          {hasCloseButton && (
            <span
              className='absolute right-4 top-4 cursor-pointer text-[#8F8F8F]'
              onClick={handleClose}
            >
              <X width={17} height={17} />
            </span>
          )}
          {children}
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
